/**
 * Client-side funnel telemetry (T12).
 *
 * POST /api/funnel/events records page-level funnel events (see
 * backend/src/services/funnel_events.py's CLIENT_FUNNEL_EVENTS allowlist —
 * this module's ClientFunnelEvent union must stay in sync with it).
 *
 * FAILURE MODE — a deliberate, documented exception to the no-silent-
 * failures rule: this call is fire-and-forget. Losing one attribution ping
 * is an acceptable trade for never blocking or erroring a page over
 * telemetry, so the caller does not await this and any network/HTTP
 * failure is swallowed here rather than surfaced.
 */

import { createHeaders } from './apiClient';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export type ClientFunnelEvent = 'pricing_viewed' | 'checkout_started';

export function recordFunnelEvent(event: ClientFunnelEvent): void {
  fetch(`${API_BASE_URL}/api/funnel/events`, {
    method: 'POST',
    headers: createHeaders(),
    body: JSON.stringify({ event }),
  }).catch(() => {
    // Silent by design — see module docstring.
  });
}
